import { cx } from '@libs/classnames';
import { AnimatedNode } from '@ui/components/Animation';
import { Button } from '@ui/components/Button/Button';

import {
  ButtonAnalize,
  ButtonCancelGame,
  ButtonClaimVictory,
  ButtonDraw,
  ButtonRematch,
  ButtonResign,
} from '@features/game/ui/GameButtons/GameButtons';

import styles from './FriendGameActions.module.css';

export function FriendGameActions({
  isFirstMove,
  isRating,
  isPlaying,
  canRequestDraw,
  canResign,
  canClaimVictory,
  canAnalyze,
  canRematch,
  rematchWaiting,
  rematchOpponentOffered,
  onCancelGame,
  onDraw,
  onResign,
  onClaimVictory,
  onAnalize,
  onRematch,
  onReturn,
}: {
  isFirstMove?: boolean;
  isRating?: boolean;
  isPlaying?: boolean;
  canRequestDraw?: boolean;
  canResign?: boolean;
  canClaimVictory?: boolean;
  canAnalyze?: boolean;
  canRematch?: boolean;
  rematchWaiting?: boolean;
  rematchOpponentOffered?: boolean;
  onCancelGame?: () => void;
  onDraw?: () => void;
  onResign?: () => void;
  onClaimVictory?: () => void;
  onAnalize?: () => void;
  onRematch?: () => void;
  onReturn?: () => void;
}) {
  if (isFirstMove && isPlaying) {
    return (
      <div className={cx(styles.actions, styles.is_first_move)}>
        <ButtonCancelGame onClick={onCancelGame}>Отменить партию</ButtonCancelGame>
        {isRating && <p>Отказ до первого хода не&nbsp;повлияет на ваш рейтинг</p>}
      </div>
    );
  }

  return isPlaying ? (
    <div className={cx(styles.actions, styles.is_playing)}>
      <AnimatedNode>
        {canClaimVictory && <ButtonClaimVictory onClick={onClaimVictory} />}
      </AnimatedNode>
      <ButtonDraw disabled={!canRequestDraw} onClick={onDraw} />
      <ButtonResign disabled={!canResign} onClick={onResign} />
    </div>
  ) : (
    <div className={cx(styles.actions, styles.is_watching)}>
      {canRematch && (
        <ButtonRematch
          disabled={rematchWaiting}
          highlight={rematchOpponentOffered}
          onClick={onRematch}
        >
          {rematchWaiting ? 'Ожидание...' : 'Реванш'}
        </ButtonRematch>
      )}
      {canAnalyze && <ButtonAnalize onClick={onAnalize}>Анализ</ButtonAnalize>}
      {onReturn && <Button onClick={onReturn}>Создать новую игру</Button>}
    </div>
  );
}
